import React from 'react';
import { Col } from 'react-bootstrap';

import BlockWrapper from '../../../components/blocks/BlockWrapper';
import GenericBlock from '../../../components/blocks/GenericBlock';
import IconBlock from '../../../components/blocks/IconBlock';
import YoutubeVideoImage from '../../../components/YoutubeVideoImage';

export default class Content extends React.Component {

    constructor(props) {
        super(props);

        this.title = 'Content';
    }

    render() {
        return (
            <BlockWrapper id="content">
                <IconBlock className="hidden-xs hidden-sm" icon="education">
                    <h3>{this.title}</h3>
                </IconBlock>

                <GenericBlock>
                    <Col md={6} sm={12} xs={12}>
                        <h4>{this.title}</h4>
                        <p>
                            Digital is changing the playing field in education. Online video and interaction formats are used to enrich the students learning experience. We produce videos for Bachelors, Masters and Executive Education for leading universities.
                        </p>

                        <h4>What clients say</h4>
                        <p>
                            <i>"We educate thousands of students online and on campus. TROI’s film studios produce compelling visual content which we develop in partnership."</i>
                        </p>
                        <p className="text-right"><i>Digital Education Officer</i></p>
                    </Col>

                    <Col md={6} sm={12} xs={12}>
                        <h4>Check out the video</h4>
                        <YoutubeVideoImage videoId="DvlUSA2TZkc" />
                    </Col>
                </GenericBlock>
            </BlockWrapper>
       );
    }

}



// WEBPACK FOOTER //
// ./src/pages/parts/universities/Content.js